import { Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  onlyThisButton: {
    opacity: 0,
    transition: "opacity 0.2s",
    padding: theme.spacing(0.5, 1),
    fontSize: 12,
    textTransform: "none",
  },
}));

interface FiltersOnlyThisButtonProps {
  className?: string;
  handleOnlyThisChange: (value: string | number) => void;
  text?: string;
}

const FiltersOnlyThisButton = (props: FiltersOnlyThisButtonProps) => {
  const { className, handleOnlyThisChange, text = "only this" } = props;
  const s = useStyles();
  return (
    <Button
      size="small"
      name="onlyThisButton"
      variant="text"
      className={clsx(s.onlyThisButton, className)}
      onClick={(e) => {
        e.stopPropagation();
        handleOnlyThisChange(e.currentTarget.value);
      }}
    >
      {text}
    </Button>
  );
};

export default FiltersOnlyThisButton;
